// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1q0fd","name":"Header_name__1dyPD","birthday":"Header_birthday__3B603","skeleton":"Header_skeleton__3hOy7"};